import { __assign, __makeTemplateObject, __rest } from "tslib";
import React, { forwardRef, useMemo } from 'react';
import MuiList from '@material-ui/core/List';
import { combineClasses, styled, useThemeProps, } from '../../../foundation';
import { ListStyle } from './styles';
import { RcListClasses } from './utils';
var _RcList = forwardRef(function (inProps, ref) {
    var props = useThemeProps({ props: inProps, name: 'RcList' });
    var classesProp = props.classes, children = props.children, rest = __rest(props, ["classes", "children"]);
    var classes = useMemo(function () { return combineClasses(RcListClasses, classesProp); }, [classesProp]);
    return (React.createElement(MuiList, __assign({}, rest, { ref: ref, classes: classes }), children));
});
var RcList = styled(_RcList)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), ListStyle);
RcList.defaultProps = {
    disablePadding: true,
};
RcList.displayName = 'RcList';
export { RcList };
var templateObject_1;
